/* eslint-disable ember/no-computed-properties-in-native-classes */
import Model, {
  attr,
  belongsTo,
  type AsyncBelongsTo,
} from '@warp-drive/legacy/model';
import { alias } from '@ember/object/computed';
import type { Type } from '@warp-drive/core/types/symbols';
import type { StatefulArray } from 'ember-data-model-fragments/array/stateful';
import { array } from 'ember-data-model-fragments/attributes';
import type Date from 'linced-app/models/date';
import type Notification from '@linc-technologies/linced-common/models/notifications/notification';
import type Person from 'linced-app/models/person';
import type School from 'linced-app/models/school';

// Proto: attendance.AlertLog.
export default class AlertLog extends Model {
  declare [Type]: 'attendance/alert-log';

  @attr('number')
  declare createTime: number | undefined;

  @belongsTo('school', { async: true, inverse: null })
  declare schoolId: AsyncBelongsTo<School>;

  @alias('schoolId')
  declare school: AsyncBelongsTo<School>;

  @attr('string', { defaultValue: '' })
  declare campusId: string; // TODO: implement when we have Campuses

  @belongsTo('date', { async: true, inverse: null })
  declare dateId: AsyncBelongsTo<Date>;

  @attr('string')
  declare date: string | undefined; // Date as a YYYY-MM-DD string

  @array('string')
  declare personIds: StatefulArray<string>;

  @belongsTo('person', { async: true, inverse: null })
  declare authorId: AsyncBelongsTo<Person>;

  @alias('authorId')
  declare author: AsyncBelongsTo<Person>;

  @belongsTo('notifications/notification', { async: true, inverse: null })
  declare notificationId: AsyncBelongsTo<Notification>;

  @alias('notificationId')
  declare notification: AsyncBelongsTo<Notification>;
}
